module.exports = __webpack_public_path__ + "static/media/students_chiffre_bg.813702eb.png";